import api from './api';

export interface Client {
  id: string;
  name: string;
  email: string;
  whatsapp: string;
}

export interface CreateClientDto {
  name: string;
  email?: string;
  whatsapp: string;
  referralCode?: string | null;
  /** Código de indicação de quem indicou — é este campo que o backend credita. */
  referredBy?: string | null;
  acceptedTerms: boolean;
  whatsappOptin: boolean;
  turnstileToken?: string;
  planSlug?: string;
  planId?: string;
  /** #389: cookies da Meta pro Lead server-side (não gravados no client). */
  fbc?: string;
  fbp?: string;
}

export interface CreateChildDto {
  name: string;
  birthdate: string;
  gender?: string;
  clientId: string;
}

export type UpdateClientDto = Partial<CreateClientDto>;

export const ClientService = {
  async getAll(): Promise<Client[]> {
    const { data } = await api.get('/clients');
    return data.data;
  },

  async getById(id: string): Promise<Client> {
    const { data } = await api.get(`/clients/${id}`);
    return data.data;
  },

  // #362: rotas públicas devolvem só o id — o dedup pode apontar pro cadastro de outra
  // pessoa, e nada além do id pode sair dali.
  async create(payload: CreateClientDto): Promise<Pick<Client, 'id'>> {
    const { data } = await api.post('/clients', payload);
    return data.data;
  },

  async update(id: string, payload: UpdateClientDto): Promise<Pick<Client, 'id'>> {
    const { data } = await api.patch(`/clients/${id}`, payload);
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/clients/${id}`);
  },
};
